<template>
  <div>
    <v-layout row class="mt-3">
      <v-flex xs5 sm2 md1 class="mr-1">
        <v-select
          :items="filter_package_list"
          item-value="package_name"
          item-text="package_name"
          v-model="filter_column"
          @change="filterBy()"
          label="Filter by"
          color="black"
          clearable
          hide-details
        ></v-select>
      </v-flex>
      <v-flex xs5 sm2 md2 class="ml-1">
        <v-select
          :items="column_items"
          item-value="value"
          v-model="sort_column"
          @change="sortBy()"
          label="Sort by"
          color="black"
          clearable
          hide-details
        ></v-select>
      </v-flex>
      <v-flex xs2 sm4 md3>
        <v-btn
          icon
          dark
          class="sort-btn mt-3"
          v-if="sort_column != 'no_default' && asc_desc == 'asc'"
          :disabled="asc_desc == 'desc' || sort_column == 'no_default'"
          @click="selectAscDesc('desc')"
        >
          <v-icon small>arrow_downward</v-icon>
        </v-btn>
        <v-btn
          icon
          dark
          class="sort-btn mt-3"
          v-if="sort_column != 'no_default' && asc_desc == 'desc'"
          :disabled="asc_desc == 'asc' || sort_column == 'no_default'"
          @click="selectAscDesc('asc')"
        >
          <v-icon small>arrow_upward</v-icon>
        </v-btn>
      </v-flex>
    </v-layout>

    <v-data-table
      :headers="headers"
      :items="store_payment_list"
      class="elevation-1 mt-4"
      style="background-color:white;padding:10px; border-radius:10px;"
    >
      <template
        slot="headerCell"
        slot-scope="props"
        style="background-color:black;"
      >{{ props.header.text }}</template>
      <template slot="items" slot-scope="props">
        <td width="5%" class="text-xs-center">{{ props.item.no }}</td>
        <!-- <td width="5%" class="text-xs-center">{{ props.item.no_default}}</td> -->
        <td width="20%">{{ props.item.store_name }}</td>
        <td width="5%" class="text-xs-center">{{ props.item.package }}</td>
        <td width="5%" class="text-xs-center">{{ props.item.order_type }}</td>
        <td width="10%">{{ props.item.bank_no }}</td>
        <td width="10%">{{ props.item.bank_name }}</td>
        <td width="10%">{{ props.item.bank_type }}</td>
        <td
          class="text-xs-right"
          width="10%"
        >{{ props.item.circulation == null ? null : (parseFloat(props.item.circulation).toFixed(2)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") }}</td>
        <td class="text-xs-center" width="10%">{{ props.item.commission }}</td>
        <td
          class="text-xs-right"
          width="10%"
        >{{ props.item.deduction == null ? null : (parseFloat(props.item.deduction).toFixed(2)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") }}</td>
        <td
          class="text-xs-right"
          width="10%"
        >{{ props.item.amount_paid ? (parseFloat(props.item.amount_paid).toFixed(2)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '0.00' }}</td>
        <td
          class="text-xs-right"
          width="10%"
        >{{props.item.total_paid ? (parseFloat(props.item.total_paid).toFixed(2)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : ''}}</td>
        <td width="5%" class="text-xs-center">
          <v-icon
            :color="props.item.remark==true ? 'green' : 'red'"
          >{{props.item.remark == true ? 'check_circle' : 'cancel'}}</v-icon>
        </td>
        <td width="15%" class="text-xs-center">
          <v-btn
            color="primary"
            class="black--text"
            :to="'/weserve_admin_login/control/' + $store.state.backOffice.province + '/report/store_payment_order/'+props.item.order_type+'/'+props.item.store_id+'/'+ search_config.order_status + '/' + search_config.datetime_start +'/' + search_config.datetime_end"
          >detail</v-btn>
        </td>
      </template>
      <template slot="footer">
        <td colspan="7" class="text-xs-center">
          <strong>Total</strong>
        </td>
        <td
          class="text-xs-right"
        >{{store_payment_summary.circulation ? (parseFloat(store_payment_summary.circulation).toFixed(2)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : store_payment_summary.circulation}}</td>
        <td></td>
        <td
          class="text-xs-right"
        >{{store_payment_summary.deduction ? (parseFloat(store_payment_summary.deduction).toFixed(2)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : store_payment_summary.deduction}}</td>
        <td
          class="text-xs-right"
        >{{store_payment_summary.amount_paid ? (parseFloat(store_payment_summary.amount_paid).toFixed(2)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : store_payment_summary.amount_paid}}</td>
        <td
          class="text-xs-right"
        >{{store_payment_summary.total_paid ? (parseFloat(store_payment_summary.total_paid).toFixed(2)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : store_payment_summary.total_paid}}</td>
        <td></td>
        <td></td>
      </template>
    </v-data-table>
    <div class="main-title mt-4 mb-3">SUMMARY</div>
    <v-card style="border-radius:10px;">
      <v-card-text>
        <v-layout justify-center>
          <v-flex xs8>
            <table width="100%">
              <tr>
                <td class="text-table">Commission WESERVE 10%</td>
                <td>{{store_payment_summary.circulation ? (parseFloat(store_payment_summary.circulation).toFixed(2)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : 'Sale sum '}}x10%</td>
                <td>{{store_payment_summary.circulation ? ((parseFloat(store_payment_summary.circulation)*(0.10)).toFixed(2)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '0.00'}}</td>
              </tr>
              <tr>
                <td class="text-table">Paid Commission</td>
                <td>{{store_payment_summary.deduction ? (parseFloat(store_payment_summary.deduction).toFixed(2)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : 'Paid'}} - {{store_payment_summary.circulation ? ((parseFloat(store_payment_summary.circulation)*(0.10)).toFixed(2)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : 'Commission WESERVE'}}</td>
                <td>{{ store_payment_summary.deduction && store_payment_summary.circulation ? ((parseFloat(store_payment_summary.deduction) - (parseFloat(store_payment_summary.circulation)*(0.10))).toFixed(2)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '0.00'}}</td>
              </tr>
              <tr>
                <td class="text-table">Paid Debase</td>
                <td>{{store_payment_summary.circulation ? (parseFloat(store_payment_summary.circulation).toFixed(2)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : 'Sum sale'}}x3%</td>
                <td
                  style="text-decoration:underline;"
                >{{store_payment_summary.circulation ? ((parseFloat(store_payment_summary.circulation)*0.03).toFixed(2)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '0.00'}}</td>
              </tr>
              <tr>
                <td colspan="2" class="text-table">Total paid</td>
                <td
                  style="text-decoration:underline;"
                >{{store_payment_summary.deduction && store_payment_summary.circulation ? parseFloat((parseFloat(store_payment_summary.deduction) - (parseFloat(store_payment_summary.circulation)*(0.10))+ parseFloat(store_payment_summary.circulation)*0.03).toFixed(2)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '0.00' }}</td>
              </tr>
            </table>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      is_loading_package: false,
      asc_desc: "asc",
      sort_column: "no_default",
      filter_column: undefined,
      isSort: false,
      headers: [
        {
          text: "No.",
          align: "center",
          sortable: false,
          value: "name"
        },
        { text: "Store name", value: "store_name", sortable: false },
        { text: "Package", value: "package", sortable: false, align: "center" },
        {
          text: "Order type",
          value: "order_type",
          sortable: false,
          align: "center"
        },
        { text: "Bank No.", value: "bank", sortable: false, align: "center" },
        { text: "Bank Name", value: "bank", sortable: false, align: "center" },
        { text: "Bank Type", value: "bank", sortable: false, align: "center" },
        {
          text: "Revenue",
          value: "circulation",
          sortable: false,
          align: "center"
        },
        {
          text: "Commission%",
          value: "Commission",
          sortable: false,
          align: "center"
        },
        {
          text: "Commission paid",
          value: "Commission_paid",
          sortable: false,
          align: "center"
        },
        {
          text: "Paid",
          value: "amount_paid",
          sortable: false,
          align: "center"
        },
        {
          text: "Total paid",
          value: "total_paid",
          sortable: false,
          align: "center"
        },
        {
          text: "Remark",
          value: "remark",
          sortable: false,
          align: "center",
          align: "center"
        },
        {
          text: "Order lists",
          value: "order_lists",
          align: "center",
          sortable: false
        }
      ],
      column_items: [
        {
          text: "Store name",
          value: "store_name",
          sortable: false,
          align: "center"
        },
        {
          text: "Total paid",
          value: "total_paid",
          sortable: false,
          align: "center"
        }
      ]
    };
  },
  watch: {
    clone_store_payment_list() {
      if (this.isSort == false) {
        this.asc_desc = "asc";
        this.sort_column = "no_default";
        this.filter_column = null;
      }
    }
  },
  computed: {
    ...mapState({
      search_config: state => state.fetchStorePaymentReport.clone_config_path,
      store_payment_list: state =>
        state.fetchStorePaymentReport.store_payment_list,
      clone_store_payment_list: state =>
        state.fetchStorePaymentReport.clone_store_payment_list,
      store_payment_summary: state =>
        state.fetchStorePaymentReport.store_payment_summary,
      filter_package_list: state => state.fetchPackageBack.package_list
    })
  },
  methods: {
    async filterBy() {
      await this.$store.commit("fetchStorePaymentReport/resetStoreList");
      if (this.filter_column != undefined) {
        const send_json_data = {
          data: this.store_payment_list,
          field: this.filter_column
        };
        await this.$store.dispatch(
          "fetchStorePaymentReport/filterDataReport",
          send_json_data
        );
      }
      await this.$store.commit("fetchStorePaymentReport/calTotalpaid");
      await this.$store.commit(
        "fetchStorePaymentReport/calStorePaymentSummary"
      );
      this.sortBy();
    },
    async sortBy() {
      if (this.sort_column == undefined) {
        this.sort_column = "no_default";
        this.asc_desc = "asc";
      }

      this.isSort = true;
      const send_json_data = {
        data: this.store_payment_list,
        field: this.sort_column,
        asc_desc: this.asc_desc
      };

      await this.$store.dispatch("sortData", send_json_data);
      await this.$store.commit(
        "fetchStorePaymentReport/getExportFormStorePayment"
      );
      this.$store.commit("fetchStorePaymentReport/getExportFormSummary");
      this.isSort = false;
    },
    selectAscDesc(value) {
      this.asc_desc = value;
      this.sortBy();
    }
  },
  async created() {
    this.is_loading_package = true;
    await this.$store.dispatch("fetchPackageBack/getPackageList", { province_name: this.$route.params.province });
    this.is_loading_package = false;
  }
};
</script>
<style scoped>
.sort-btn {
  cursor: pointer;
  height: 30px;
  width: 30px;
  background-color: #fafafa;
  border: 1px solid #b8b8b8;
  border-radius: 10px;
  color: #757575;
  margin-top: 10px;
  margin-left: 20px;
}

.main-title {
  font-size: 22px;
  font-weight: bold;
}
.text-table {
  font-weight: bold;
  line-height: 30px;
}
</style>

